export const PAYMENT_PLANS_FALLBACK = {
    currency: 'GEL',
    maxTransactionGel: 50,
    top: { premium: 39, top1: 25, top2: 15, top3: 10, bump: 2 },
    highlight: { highlight_week: 5, highlight_month: 12 },
    bundle: { bundle_premium_highlight: 45 },
    accountPremium: { week: 5, '2week': 12, month: 25 },
    advertsUser: {
        standart: { gel: 5, quantity: 1 },
        premium: { gel: 9, quantity: 2 },
    },
    advertsCorp: {
        standart: { gel: 10, quantity: 5 },
        premium: { gel: 25, quantity: 15 },
        unlim: { gel: 45, quantity: 100 },
    },
};
